"use strict";var inherit = require("raptor-util/inherit");
var VNode = require("./VNode");

function VText(value, ownerComponent) {
  this.bY_(-1 /* no children */, ownerComponent);
  this.bZ_ = value;
}

VText.prototype = {
  cq_: true,

  c__: 3,

  br_: function (host) {
    return (host.ownerDocument || host).createTextNode(this.bZ_);
  },

  bS_: function () {
    return new VText(this.bZ_);
  }
};

inherit(VText, VNode);

module.exports = VText;